module.exports = __webpack_public_path__ + "static/img/05.aa3aaf7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cultours/tour6/05.jpg
// module id = kVra
// module chunks = 0